import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { chatSdk, Constants, } from '@wix/chat-sdk';
export var withGlobalUnread = function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleGlobalUnreadChange = function (_a) {
                var count = _a.count, overflow = _a.overflow;
                _this.setState({
                    unreadCount: count,
                    unreadOverflow: overflow,
                });
            };
            return _this;
        }
        class_1.prototype.isExperimentOn = function () {
            return chatSdk.isExperimentOn(Constants.experiments.GlobalUnreadRoomsCounter);
        };
        class_1.prototype.componentDidMount = function () {
            if (this.isExperimentOn()) {
                this.setState({
                    unreadCount: 0,
                    unreadOverflow: false,
                });
                this.subscription = chatSdk.subscribeToGlobalUnreadStatus({
                    callback: this.handleGlobalUnreadChange,
                });
            }
        };
        class_1.prototype.componentWillUnmount = function () {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        };
        class_1.prototype.render = function () {
            var globalUnreadProps = this.isExperimentOn() ? this.state : {};
            // `as P` can be removed once the following issue closes
            // https://github.com/Microsoft/TypeScript/issues/28884
            var injectedProps = __assign(__assign({}, this.props), globalUnreadProps);
            return React.createElement(WrappedComponent, __assign({}, injectedProps));
        };
        return class_1;
    }(Component));
};
//# sourceMappingURL=withGlobalUnread.js.map